module.exports = __webpack_public_path__ + "img/public/siteImages/noWishList.svg?57534973";